import { createSelectors } from "../helpers";
import { useAuthStore } from "./store";

export const useAuthStoreSelectors = createSelectors(useAuthStore);
